import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import CardHeader from "../../components/Card/CardHeader";
import EditIcon from "@material-ui/icons/Edit";
import {
  addNewDistance,
  getAllDistance,
  updateDistance,
} from "../../store/actions/admin/Admin";
import { Button, Slider } from "@material-ui/core";
import { connect } from "react-redux";
import {makeStyles} from "@material-ui/core/styles"
const useStyles = makeStyles((theme) => ({
  typo: {
    paddingLeft: "25%",
    marginBottom: "40px",
    position: "relative",
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: "10px",
    color: "#c0c1c2",
    display: "block",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "13px",
    left: "0",
    marginLeft: "20px",
    position: "absolute",
    width: "260px",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  sliderUpdate: {
    display: "flex",
    alignItems: "center",
	},
	addButton: {
		position: "fixed",
		width: "60px",
		height: "60px",
		bottom: "40px",
		right: "20px",
		backgroundColor: "#A742B9",
		color: "#FFF",
		borderRadius: "50px",
		textAlign: "center",
		boxShadow: "2px 2px 3px #A742B9",
	}
}));

const Circumstance = ({ getAllDistance, distance, updateDistance }) => {

  const classes = useStyles();
	const [isEdit, updateEdit] = useState(false);
  const [addNew, updateAddNew] = useState(false);
  const [adminDistance, updateAdminDistance] = useState({distance: 0});

  useEffect(() => {
    getAllDistance();
  }, []);

  useEffect(() => {
    if (distance) {
      const payload = {
        distanceId: distance.id,
        distance: distance.distance,
      };
      updateAdminDistance(payload);
    } else {
      updateAddNew(true);
    }
  }, [distance]);

  const handleDistanceChange = (data, number) => {
    const tempDistance = { ...adminDistance };
    tempDistance.distance = number;
    updateAdminDistance(tempDistance);
  };

  const submitDistance = () => {
    if(isEdit) {
      updateDistance(adminDistance).then((data) => {
        if (data) {
          updateEdit(!isEdit);
        }
      });
    }

    if(addNew) {
      addNewDistance(adminDistance).then((data) => {
        if (data) {
          updateAddNew(!addNew);
        }
      })
    }
  };

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>All Distance - Add, Update</h4>
        <p className={classes.cardCategoryWhite}>
          PNG Images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Distance</th>
            <th>Update</th>
          </tr>
        </thead>
        <tbody>
          {adminDistance ? (
            <tr>
              <th scope="row">1</th>
              <td>
                {isEdit || addNew ? (
                  <div className={classes.sliderUpdate}>
                    <Slider
                      onChangeCommitted={handleDistanceChange}
                      step={0.1}
                      min={0.1}
                      max={10}
                      defaultValue={parseInt(adminDistance.distance) || 0}
                      aria-labelledby="input-slider"
                      valueLabelDisplay="auto"
                    />
                    <Button onClick={submitDistance} color="primary">
                      {isEdit ? 'Update' : 'Add'}
                    </Button>
                  </div>
                ) : (
                  adminDistance.distance
                )}
              </td>
              <td>
                <EditIcon onClick={() => updateEdit(!isEdit)} />
              </td>
            </tr>
          ) : (
            <tr>
              <td>No data yet..</td>
              <td>No data yet..</td>
              <td>No data yet..</td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};

const mapStateWithProps = (state) => ({
  distance: state.admin.distance,
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllDistance: () => dispatch(getAllDistance()),
    addNewDistance: () => dispatch(addNewDistance()),
    updateDistance: (distance) => dispatch(updateDistance(distance)),
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(Circumstance);
